"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 导出失败的 Icon
 * url: https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/f82c146e-aee7-4fa1-8956-905f008126ec
 * name: IcLinePageListBack
 */
function IcLinePageListBack() {
    return null;
}
exports.default = IcLinePageListBack;
;
